import React from 'react';
import { cn } from '../../shared/utils/cn';
import { CampaignPreviewSection } from './CampaignPreviewSection';
import { SocialProof } from './SocialProof';

interface HeroSectionProps {
  compact?: boolean; // When true, shows minimal content (mobile)
}

export const HeroSection: React.FC<HeroSectionProps> = ({ compact = false }) => {
  return (
    <div className={cn(
      "relative w-full flex flex-col justify-center items-center text-center",
      compact ? "pt-4 pb-2" : "h-full pt-0 pb-4 lg:pt-4 lg:pb-8"
    )}>
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 dark:from-blue-950/20 dark:via-indigo-950/20 dark:to-purple-950/20" />
      
      {/* Content */}
      <div className={cn(
        "relative z-10 w-full",
        compact ? "max-w-md px-4" : "max-w-3xl px-4 lg:px-10"
      )}>
        {/* Logo */}
        <div className={cn(
          "flex justify-center",
          compact ? "mb-0" : "mt-2 mb-4 lg:mt-6 lg:mb-10"
        )}>
          <img 
            src="https://psezrfpnqxfxupfutlnq.supabase.co/storage/v1/object/public/assets/videreo_logo.png"
            alt="Videreo Logo" 
            className={cn(
              "w-auto",
              compact ? "h-6 max-w-[120px]" : "h-8 lg:h-16 max-w-[200px]"
            )} 
          />
        </div>

        {/* Desktop-only content: Campaigns, Social Proof (BenefitsSection removed) */}
        {!compact && (
          <>
            {/* Campaign previews */}
            <div className="mt-2 lg:mt-4">
              <CampaignPreviewSection />
            </div>

            {/* Social proof at the bottom, no background box */}
            <div className="mt-2 lg:mt-4">
              <SocialProof />
            </div>
          </>
        )}
      </div>
    </div>
  );
};
